import React, { useEffect, useState } from "react";
import axios from "axios";

import {
    Paper,
    Typography,
    CircularProgress,
    Alert,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Link
} from "@mui/material";

import {
    Description,
    PictureAsPdf,
    Image,
    TableChart,
    Slideshow,
    FolderZip,
    Code,
    InsertDriveFile
} from "@mui/icons-material";

const API_URL =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5000";

export default function FileList({

    folderPath,
    onFolderSelect
}) {

    const [files, setFiles] = useState([]);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    useEffect(() => {

        loadFiles();

    }, [folderPath]);

    async function loadFiles() {

        try {

            setLoading(true);

            setError("");

            const response = await axios.get(

                `${API_URL}/knowledge`

            );

            const documents = response.data || [];

            if (!folderPath) {

                setFiles(documents);

                return;

            }
const filtered = documents.filter(item => {

    if (!folderPath) {

        // Root level
        return item.parentFolder === "";
    }

    const parentPath =
        item.folderPath.includes("/")
            ? item.folderPath.substring(
                  0,
                  item.folderPath.lastIndexOf("/")
              )
            : "";

    // Immediate child folders
    if (item.type === "folder") {
        return parentPath === folderPath;
    }

    // Immediate child files
    return item.folderPath === folderPath;

});
            setFiles(filtered);

        }

        catch (err) {

            console.error(err);

            setError("Unable to load files.");

        }

        finally {

            setLoading(false);

        }

    }
        function getIcon(icon) {

        switch (icon) {

            case "pdf":

                return <PictureAsPdf color="error" />;

            case "word":

                return <Description color="primary" />;

            case "excel":

            case "csv":

                return <TableChart color="success" />;

            case "powerpoint":

                return <Slideshow color="warning" />;

            case "archive":

                return <FolderZip color="secondary" />;

            case "image":

                return <Image color="success" />;

            case "code":

                return <Code color="info" />;

            default:

                return <InsertDriveFile />;
        }

    }

    if (loading) {

        return (

            <Paper
                sx={{
                    p: 3,
                    height: "100%"
                }}
            >

                <Box
                    display="flex"
                    justifyContent="center"
                >

                    <CircularProgress />

                </Box>

            </Paper>

        );

    }

    if (error) {

        return (

            <Paper
                sx={{
                    p: 3
                }}
            >

                <Alert severity="error">

                    {error}

                </Alert>

            </Paper>

        );

    }
        return (

        <Paper

            elevation={2}

            sx={{

                p: 2,

                height: "100%",

                overflow: "auto"

            }}

        >

            <Typography

                variant="h6"

                fontWeight="bold"

                gutterBottom

            >

                Files

                {

                    folderPath &&
                    ` — ${folderPath}`

                }

            </Typography>

            {

                files.length === 0 ?

                (

                    <Alert severity="info">

                        No files found in this folder.

                    </Alert>

                )

                :

                (

                    <Table
                        size="small"
                    >

                        <TableHead>

                            <TableRow>

                                <TableCell>

                                    Name

                                </TableCell>

                                <TableCell>

                                    Type

                                </TableCell>

                                <TableCell
                                    align="right"
                                >

                                    Size

                                </TableCell>

                                <TableCell>

                                    Modified

                                </TableCell>

                                <TableCell>

                                    Open

                                </TableCell>

                            </TableRow>

                        </TableHead>

                        <TableBody>

                            {

                                files.map(file => (

                                    <TableRow
                                        key={file.id}
                                        hover
    sx={{
        cursor: file.type === "folder" ? "pointer" : "default"
    }}
    onClick={() => {
        if (file.type === "folder" &&
            onFolderSelect) {
            onFolderSelect(file.folderPath);
        }
    }}
                                    >

                                        <TableCell>

                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                gap={1}
                                            >

                                                {

                                                    getIcon(file.icon)

                                                }

                                                <Typography
                                                    variant="body2"
                                                >

                                                    {file.title}

                                                </Typography>

                                            </Box>

                                        </TableCell>

                                        <TableCell>

                                            {

                                                file.extension ||

                                                file.mimeType

                                            }

                                        </TableCell>

                                        <TableCell
                                            align="right"
                                        >

                                            {

                                                file.size
                                                    ? `${Math.round(file.size / 1024)} KB`
                                                    : "-"

                                            }

                                        </TableCell>

                                        <TableCell>

                                            {

                                                file.modifiedTime
                                                    ? new Date(file.modifiedTime).toLocaleString()
                                                    : "-"

                                            }

                                        </TableCell>

                                        <TableCell>

                                            <Link

                                                href={file.webViewLink}

                                                target="_blank"

                                                rel="noopener noreferrer"

                                            >

                                                Open

                                            </Link>

                                        </TableCell>

                                    </TableRow>

                                ))

                            }

                        </TableBody>

                    </Table>

                )

            }

        </Paper>

    );

}